const validators = {
  criterionKey: {
    pattern: /^[A-Za-z0-9_]{3,15}$/,
    message: `
    Only criteria keys with alphabets, numbers and underscores between 3 and
    15 characters long are allowed.`
  },
  flowName: {
    pattern: /^[A-Za-z0-9_:,]{3,30}$/,
    message: `
    Only flow names with alphabets, numbers and '_', ':' or ',' between 3 and 
    and 30 characters long are allowed.`
  },
  promptKey: {
    pattern: /^[A-Za-z0-9_]{3,15}$/,
    message: `
    Only prompt keys with alphabets, numbers and underscores between 3 and
    15 characters long are allowed.`
  },
  answerId: {
    pattern: /^[A-Za-z0-9_]{3,15}$/,
    message: `
    Only answer ids with alphabets, numbers and underscores between 3 and
    15 characters long are allowed.`
  },
  answerTrackingId: {
    pattern: /^[A-Za-z0-9_]{3,15}$/,
    message: `
    Only answer tracking ids with alphabets, numbers and underscores between 
    3 and 15 characters long are allowed.`
  }
};

export default validators;
